export const LAYER_NAME_UPSELL_ACTIVITIES = 'UpsellActivities';
export const LAYER_NAME_UPSELL_CHILDCARES = 'UpsellChildcares';
export const LAYER_NAME_UPSELL_ESF = 'UpsellESF';
export const LAYER_NAME_UPSELL_INSURANCES = 'UpsellInsurances';
export const LAYER_NAME_UPSELL_PACKAGES = 'UpsellPackages';
export const LAYER_NAME_UPSELL_RENTALS = 'UpsellRentals';
export const LAYER_NAME_UPSELL_TRANSFERS = 'UpsellTansfers';
export const LAYER_NAME_STAY_STAFF = 'StayStaff';
export const LAYER_NAME_VOUCHERS = 'Vouchers';
export const LAYER_NAME_UPGRADE_ROOM = 'UpgradeRoom';
